import { yup } from "@";

const reqWhen = (provider) =>
  yup.string().when("provider", {
    is: provider,
    then: (s) => s.required("هذا الحقل مطلوب"),
    otherwise: (s) => s.nullable().notRequired(),
  });

export const schema = yup
  .object({
    provider: yup
      .string()
      .oneOf(["myfatoorah", "paymob", "moyasar"])
      .required(),

    // MyFatoorah
    myfatoorahApiKey: reqWhen("myfatoorah"),
    myfatoorahCountry: reqWhen("myfatoorah"),
    myfatoorahWebhookSecret: yup.string().nullable(),
    myfatoorahIsLive: yup.boolean(),

    // Paymob
    paymobApiKey: reqWhen("paymob"),
    paymobIntegrationId: reqWhen("paymob"),
    paymobIframeId: reqWhen("paymob"),
    paymobHmacSecret: yup.string().nullable(),
    paymobIsLive: yup.boolean(),

    // Moyasar
    moyasarPublishableKey: reqWhen("moyasar"),
    moyasarSecretKey: reqWhen("moyasar"),
    moyasarWebhookSecret: yup.string().nullable(),
    moyasarIsLive: yup.boolean(),
  })
  .required();

export const defaultValues = {
  provider: "myfatoorah",

  myfatoorahApiKey: "",
  myfatoorahCountry: "SAU",
  myfatoorahWebhookSecret: "",
  myfatoorahIsLive: false,

  paymobApiKey: "",
  paymobIntegrationId: "",
  paymobIframeId: "",
  paymobHmacSecret: "",
  paymobIsLive: false,

  moyasarPublishableKey: "",
  moyasarSecretKey: "",
  moyasarWebhookSecret: "",
  moyasarIsLive: false,
};
